import { useQuery } from '@tanstack/react-query';
import { Api } from '../api/Api';
import Links from '../constants/Links';

export const useGalleries = () => {
    return useQuery({
        queryKey: ['galleries'],
        queryFn: Api.getGalleriesList,
        select: (data) => {
            return data.map((gallery) => ({
                id: gallery.id,
                css: `${Links.ESERUYANIK_API}gallery/${gallery.id}/cover`,
                width: gallery.width,
                height: gallery.height,
                title: gallery.title,
            }));
        },
    });
};

export const useGalleryPhotographs = (galleryId: string | number) => {
    return useQuery({
        queryKey: ['gallery-photographs', galleryId],
        queryFn: () => Api.getGalleryContent(galleryId),
        enabled: !!galleryId,
        select: (data) => {
            return data.photographs.map((photo) => ({
                id: photo.id,
                src: `${Links.ESERUYANIK_API}photograph/${photo.id}`,
                width: photo.width,
                height: photo.height,
            }));
        },
    });
};
